export default "__VITE_ASSET__VHKVbb02__"